import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  hover?: boolean;
}
export function Card({
  children,
  className = '',
  onClick,
  hover = true
}: CardProps) {
  return <div className={`bg-white rounded-xl border border-gray-200 ${onClick ? 'cursor-pointer' : ''} ${hover && onClick ? 'hover:shadow-md hover:border-gray-300' : 'shadow-soft'} transition-all duration-200 ${className}`} onClick={onClick} data-id="element-242">
      {children}
    </div>;
}